// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".example-panel[data-v-80c73e32] .v-expansion-panel-header{min-height:1.2em}.loading-container[data-v-80c73e32]{padding-bottom:calc(56.25% - 70px)}.video-container[data-v-80c73e32]{padding-bottom:56.25%;position:relative}.video-container .vimeo-player[data-v-80c73e32]{border:0;height:100%;left:0;position:absolute;top:0;width:100%}.video-container .vimeo-player[data-v-80c73e32] iframe{height:100%!important;width:100%!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
